var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-5",attrs:{"id":"page-done-books"}},[_c('BookTable',{attrs:{"books":_vm.local_books,"showError":false,"type":"done"},on:{"selectBookClicked":_vm.selectBook,"deleteBookClicked":_vm.deleteBook}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }